// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi } from '@reduxjs/toolkit/query/react'

import { adminApiBaseQuery } from '@/store/query'
import { serializeWithTenantId } from '@/store/utils'

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptyTemplateApi = createApi({
  baseQuery: adminApiBaseQuery,
  // allow refetch all subscribed queries after regaining a network connection
  refetchOnReconnect: true,
  // cache expired after 10 seconds
  refetchOnMountOrArgChange: 10,
  serializeQueryArgs: serializeWithTenantId,
  endpoints: () => ({})
})
